import { useState } from "react"
import useLoading from "../../../components/Common/useLoading"
import InventoryLaboratoryKitService from "../../../api/Inventory/InventoryLaboratoryKitService";

export function useLaboratoryKit(laboratoryKitId){
    const [laboratoryKit, setLaboratoryKit] = useState({
        presentation: "",
        laboratoryKitId: 0,
    })
    const [isLoading, reload] = useLoading({
        onLoad: async () => {
            if(laboratoryKitId == undefined || laboratoryKitId == 0) return;

            const result = await InventoryLaboratoryKitService.GetById(laboratoryKitId)

            if(result.Succeeded){
                const laboratoryKit = result.Value
                setLaboratoryKit(laboratoryKit)
            }
        }
    })

    return [laboratoryKit, isLoading, reload]
}